const lang = {
    "Kep": "QES",
    "KepNotLinked": "Ihre QES ist noch mit keinem Konto verknüpft. Melden Sie sich wie gewohnt an – wir verknüpfen sie.",
    "KepNewAccount": "Kein Konto? Registrieren",
    "KepLinked": "QES mit dem Konto verknüpft",
    "KepLinkFailed": "QES konnte nicht verknüpft werden. Melden Sie sich erneut mit QES an – wir verknüpfen sie",
    "KepFile": "Schlüsseldatei",
    "ErrorKepLogin": "Anmeldung mit QES fehlgeschlagen",
    "EnterWidth": "Einloggen mit:",
    "Registration": "Registrieren",
    "enter": "Betreten",
    "EntrWidthEmailOrPhone": "Mit E-Mail oder Telefon anmelden",
    "login": "Genehmigung",
    "NoAkkGoReg": "Registrieren",
    "Password": "Passwort",
    "Name": "Name",
    "LastName": "Familien-oder Nachname",
    "Phone": "Zur Registrierung geben Sie Ihre Telefonnummer ein",
    "Email": "Post",
    "RepeatPassword": "Passwort wiederholen",
    "Сancel": "Absagen",
    "Save": "Speichern",
    "Language": "Sprache",
    "ConfirmThisMail": "Deine Email wurde bestätigt",
    "Saved": "Gerettet",
    "Error": "Fehler",
    "FillInAllTheFields": "Füllen Sie alle Felder aus",
    "Next": "Weiter",
    "MinPassLength": "Minimale Passwortlänge 4 Zeichen",
    "ForgotYourPassword": "Passwort vergessen",
    "RestorePassword": "Bitte legen Sie ein neues Passwort fest.",
    "UserMustBeRegistered": "Benutzer muss registriert sein",
    "Confirm": "Bestätigen Sie",
    "WrongFormat": "Falsches Format",
    "WrongPassword": "Falsches Passwort",
    "WrongLoginOrPassword": "falsches Login oder Passwort",
    "PhoneAlreadyRegistered": "Telefon bereits registriert",
    "EmailAlreadyRegistered": "Post bereits registriert",
    "FillInTheFieldsCorrectly": "Füllen Sie die Felder richtig aus",
    "ThisAccountDoesNotExist": "Dieser Account existiert nicht",
    "LinkIsNotValid": "Link ist nicht gültig",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Eine Nachricht wurde an den angegebenen Benutzernamen gesendet",
    "IncorrectCaptcha": "Falsches Captcha",
    "CaptchaIsNotValid": "Captcha ist nicht mehr gültig",
    "EnterCaptcha": "Captcha eingeben",
    "EnterSMS": "Code aus SMS eingeben",
    "SMSCodeIsNoLongerValid": "SMS-Code ist nicht mehr gültig",
    "SMSCodeIsIncorrect": "SMS-Code ist falsch",
    "MailNotVerifiedLinkTimedOut": "Mail nicht bestätigt, Link abgelaufen",
    "DemoLogin": "Demo-Login",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Möchten Sie wirklich an der <b> Demo </b> , um es auszuprobieren?",
    "FillInAdditionalInformation": "Füllen Sie zusätzliche Informationen aus",
    "ToCompleteRegistration": "Um die Registrierung abzuschließen",
    "LinkThirdPartyServices": "Dienste von Drittanbietern verknüpfen",
    "Complete": "Fertigstellen",
    "AccountAlreadyLinked": "Konto bereits verknüpft",
    "AccountNotRegistered": "Konto nicht registriert",
    "NotMyNumber": "Nicht meine Nummer",
    "Back": "zurück",
    "numberOfAttemptsToCheckAuth": "Anzahl Anmeldeversuche:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Falsches Passwort, Anzahl Anmeldeversuche:",
    "TryAgainAfterMinute": "Bitte versuchen Sie es in 2 Minuten erneut",
    "Help": "Unterstützung",
    "y": "Ja",
    "n": "Nein",
    "doYouConfirmEmail": "Möchten Sie Ihre E-Mail-Adresse wirklich ändern?",
    "success": "Erfolgreich",
    "goToAutorize": "Gehen Sie zur Autorisierung",
    "UserEmailAlreadyExists": "Ein Benutzer existiert bereits mit dieser E-Mail-Adresse",
    "UserPhoneAlreadyExists": "Benutzer mit dieser Telefonnummer existiert bereits",
    "TermOfUse": "Nutzungsbedingungen",
    "PrivacyPolicy": "Datenschutz-Bestimmungen",
    "accountNotRegistered": "Konto nicht registriert",
    "wantToReg": "Möchten Sie sich anmelden?",
    "weSuccessChangeYouEmail": "Wir haben Ihre E-Mail-Adresse erfolgreich geändert",
    "youCanCloseThisWindow": "Sie können dieses Fenster schließen",
    "countryConfirm": "Länderbestätigung",
    "EmailAlreadyTied": "Mail ist bereits mit einem anderen Konto verknüpft",
    "areYourCountry": "Ist das dein Land?",
    "EmergencyEntrance": "Alte Zulassung",
    "enterCorrectNumber": "Nummer im internationalen Format eingeben",
    "thisPhoneRegister": "Diese Telefonnummer ist bereits im System registriert",
    "wantUsePhoneForAuth": "Möchten Sie sich mit dieser Telefonnummer anmelden?",
    "ok": "ok",
    "regAgree": "Durch die Registrierung eines Kontos akzeptiere ich",
    "wantBind": "Sie möchten sich anmelden und den Dienst verknüpfen",
    "bind": "binden",
    "yoursMailBinded": "Ihre E-Mail-Adresse befindet sich in einem bestehenden Konto",
    "wantUsePhoneAndBind": "bereits im System registriert",
    "notGetDataFromApple": "Es konnten keine Daten von Apple empfangen werden",
    "ErrorAppleLogin": "Fehler bei der Autorisierung über Apple",
    "ErrorGoogleLogin": "Fehler bei der Autorisierung über Google",
    "ErrorTelegramLogin": "Fehler beim Einloggen über Telegram",
    "ErrorFacebookLogin": "Fehler beim Anmelden über Facebook",
    "EMailOrPhone": "Bitte geben Sie eine gültige Telefonnummer oder E-Mail-Adresse ein.",
    "withoutName": "Kein Name",
    "goToCabinet": "Zum Büro",
    "Logout": "Sitzung beenden",
    "creationDate": "Erstellungsdatum",
    "preparingCompany1": "Wir gründen Ihr Unternehmen, geben Sie uns bitte eine Minute …",
    "preparingCompany2": "Wir bereiten eine Schnittstelle zur Verwaltung von Waren und Dienstleistungen vor …",
    "preparingCompany3": "Wir arbeiten an einer komfortablen Finanzbuchhaltung…",
    "preparingCompany4": "Wir nehmen die letzten Einstellungen vor, fast fertig …",
    "companyBlocked": "Dieses Unternehmen ist inaktiv",
    "youBlockedInComp": "Benutzer ist nicht aktiv, Anmeldung nicht möglich",
    "loginTitle": "Alles, was ein Unternehmen braucht, an einem Ort",
    "loginDescr": "Automatisierung für Geschäfte, Cafés, Lieferdienste, Restaurants, Lager, Produktion oder Dienstleistungen",
    "NoAkkGoRegText": "Sie haben noch kein Konto?",
    "LoginPlaceholder": "Bitte geben Sie die erforderlichen Informationen an",
    "loginText": "Hast du schon ein Konto?",
    "and": "Und",
    "AcceptTheTerms": "Bitte akzeptieren Sie die Datenschutzbestimmungen und Nutzungsbedingungen",
    "CountryPhoneFormat": "Wenn dies nicht Ihr Land ist, überprüfen Sie bitte, ob Sie Ihre Telefonnummer im richtigen internationalen Format eingegeben haben.",
    "SaveNewPassword": "Neues Passwort speichern"
}

export default function() {
    return lang;
}